import ActionCableLink from 'graphql-ruby-client/subscriptions/ActionCableLink'
import { getAccessToken } from 'helpers/accessToken'

export default cable => {
  const connectionParams = { accessToken: getAccessToken() }
  return new ActionCableLink({ cable, connectionParams })
}
